import { Router } from '@angular/router';
import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ViewChildren, QueryList, Injectable } from '@angular/core';
import { MatDialog, MatSnackBar, MatDialogConfig } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl, Form } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { Observable, BehaviorSubject, iif, Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatNumber } from '@angular/common';
import { timeout, startWith, map } from 'rxjs/operators';
import { formControlBinding } from '@angular/forms/src/directives/reactive_directives/form_control_directive';
import { RutValidator } from 'ng2-rut';
import { HttpHandler } from '@angular/common/http';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { PerfilComponent } from '../perfil/perfil.component';

import * as FormActions from '../../reducers/actions/forms.actions';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { GLOBAL } from 'src/app/services/global';
import { ValueTransformer } from '@angular/compiler/src/util';
import { element } from 'protractor';
import { I } from '@angular/cdk/keycodes';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';

interface AppState {
    form: Form;
}

declare const swal: any;
@Injectable()
@Component({
    selector: "page-solicitud_certificados",
    templateUrl: "solicitud_certificados.component.html",
    styleUrls: ["./solicitud_certificados.component.css"],
    providers: [UserService, PropiedadService, ClaveUnicaService]
})

export class Solicitud_certificadosComponent {
    @ViewChild('modalSolicitarCertificado') modal_sol_cert: TemplateRef<any>;
    @ViewChildren('myCheckbox') private myCheckboxes: QueryList<any>;
    @ViewChild('openModalPago') openModalPago: TemplateRef<any>;
    @ViewChild('openModalPago') openModalPagoFinal: TemplateRef<any>;
    @ViewChild('finalizarMSG') finalizarMSG: TemplateRef<any>;
    @ViewChild('pagoInProcess') pagoInProcess: TemplateRef<any>;
    @ViewChild('direccionesDialog') direccionesDialog: TemplateRef<any>;
    @ViewChild('modalDocumentos') modalDocumentos: TemplateRef<any>;
    public global = GLOBAL
    isLinear = true;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    thirdFormGroup: FormGroup;

    info_rut
    displayedColumns: string[] = ['rol', 'direccion', 'actions'];
    dialogConfig
    btnDisabled = true

    continuar = false


    public pago_portal: Subscription;
    public pago_finalizado: Subscription;
    public pago_desconectar: Subscription;
    public pago_nuevonumero: Subscription;
    public pago_fallido: Subscription;


    //calculo valores certificados
    valores_cert = []
    valores_cert_noformat = []
    valorOnlyCert = 0
    valorTotalEstampilla = 0
    certSelected = []
    valor_total_cert = 0
    cert = []
    mostrar_total
    mostrar_total2

    //forms
    public rut = new FormControl('');
    public rol = new FormControl('');
    public dir = new FormControl('');
    public num = new FormControl('');
    public correo = new FormControl('');
    public nombre = new FormControl('');
    public telefono = new FormControl('');
    public url_fracaso = new FormControl('');
    public url_exito = new FormControl('')


    public numAsig = [1, 1, 1]
    public observacion = new FormControl('')
    public mostrarNum = false


    //direcciones agregadas
    lista_dir = new BehaviorSubject([])
    dirs = []
    identity
    token

    //banderapago
    pagando = false

    //banderas
    mostrar_solicitud = false
    primerPaso = false
    segundoPaso = false
    tercerPaso = false
    primerPaso_mod = false
    modificando = false
    rut_encontrado = false
    valores_cert_recibidos = false
    cert_seleccionado = false
    folio
    rutcarro
    lista_cert_seleccionados = []
    filteredOptions
    emailValido = false
    public nombreMuni = GLOBAL.nombreMuni;
    public webUrl = GLOBAL.webUrl;
    public web = GLOBAL.web;
    public footer = GLOBAL.footer;


    public searchText = ""





    arrayItems: {
        nombre: string;
        aup: boolean;
        cip: boolean;
        num: boolean;
        zn: boolean;
    }[];


    ////pago carro 
    id_carro
    carro_deptos
    infoPago
    bandera
    calles

    //manejo de direcciones
    dirrecciones
    dirSeleccionada

    //cantidad de certificados seleccionados
    cantidadCert = 0
    documentos_obligatorios = [
        // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' },
        // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' },
        // { selected: false, doc_obg_name: 'Avalúo Fiscal', doc_obg_name_id: '' }
        false,
        false,
        false

    ];
    public dbx_links = [];

    cargando: boolean;

    public seleccion_nameCert = ""
    public seleccion_dire = ""
    public seleccion_num = ""
    public seleccion_rol = ""
    public seleccion_cert = ""
    public certificadoSeleccionado
    public peso
    public archivosSubidos = false
    obligatorios: boolean;

    dialogRef: any;
    public files = []
    public rowsObligatorios = []
    public actualSizeFiles = 0
    public rows1 = [{ total: 0 }]

    nombreArchivo: string;
    public archivoCargado;
    public documentoNombre = '';
    btnAccept: boolean;
    pase: boolean;

    public maxSizeFiles = 75000000

    constructor(private dialog: MatDialog, private _prop: PropiedadService, private _formBuilder: FormBuilder,
        private _userService: UserService, private snackBar: MatSnackBar, private spinner: NgxSpinnerService,
        private _changeDetector: ChangeDetectorRef, private rutValidator: RutValidator, private _router: Router,
        private store: Store<AppState>,
        private claveUnicaService: ClaveUnicaService) {
        this.spinner.show()

        this._prop.getCalles().subscribe(response => {
            this.calles = response.calles
            this.bandera = true
            console.log(this.calles)
            /* console.log(response.calles) */
            this._userService.get_valores_cert().subscribe(
                res => {
                    console.log("valores", res)

                    for (let i = 0; i < res.certs.length; i++) {
                        const element = res.certs[i];
                        this.valores_cert.push({
                            alias: element.TRAEXP_Alias,
                            nombre: element.TRAEXP_Tipo,
                            corvi: element.TRAEXP_Monto,
                            plazo: element.TRAEXP_DiasPlazo,
                            tipoPlazo: element.TRAEXP_Dia_Habil,
                            valor: formatNumber(Math.round((element.TRAEXP_Tipo_Moneda == "CORVI" ? (element.TRAEXP_corvi * res.corvi) : (element.TRAEXP_UTM * res.utm))), 'cl'),
                            valorNoFormat: Math.round((element.TRAEXP_Tipo_Moneda == "CORVI" ? (element.TRAEXP_corvi * res.corvi) : (element.TRAEXP_UTM * res.utm))),
                            estampilla: element.TRAEXP_Valor_Estampilla
                        })
                        this.valores_cert_noformat.push({
                            alias: element.TRAEXP_Alias,
                            nombre: element.TRAEXP_Tipo,
                            corvi: element.TRAEXP_Monto,
                            plazo: element.TRAEXP_DiasPlazo,
                            valor: Math.round((element.TRAEXP_Tipo_Moneda == "CORVI" ? (element.TRAEXP_corvi * res.corvi) : (element.TRAEXP_UTM * res.utm))),
                            estampilla: element.TRAEXP_Valor_Estampilla
                        })
                    }


                    /*  console.log(this.valores_cert) */
                    console.log(this.valores_cert_noformat)
                    this.spinner.hide()
                    this.valores_cert_recibidos = true
                   // this.dialog.closeAll()

                }, error => {
                    console.log(error)
                }

            )
        }, error => {
            console.log(error)
        })

        this.rut = new FormControl("", Validators.required)

        this.dialogConfig = new MatDialogConfig();
        this.dialogConfig.disableClose = true;
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();


    }

    ngOnInit() {

        /*   this.spinner.show() */
        this.arrayItems = [];

        this.firstFormGroup = this._formBuilder.group({
            rut: ['', [Validators.required, this.rutValidator]],
            mod_solicitante: this._formBuilder.group({
                nombre: ['', [Validators.required]],
                apellido_p: [''],
                apellido_m: [''],
                calle: ['', [Validators.required]],
                num: ['', [Validators.required]],
                complemento: [''],
                telefono: [''],
                cel: ['', [Validators.required]],
                ciudad: [''],
                comuna: [''],
                email: ['', [Validators.required, Validators.email]]
            })
        });
        this.secondFormGroup = this._formBuilder.group({
            rol: this.rol,
            dir: this.dir,
            num: this.num
        });
        this.thirdFormGroup = this._formBuilder.group({

        })





        this.filteredOptions = this.secondFormGroup.controls.dir.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value))
        );

        if (sessionStorage.getItem('identity-domCloud')) {
            let identityData = this._userService.getIdentity();
            this.firstFormGroup.controls['rut'].setValue(identityData.rut + '-' + identityData.dv);
            this.searchUser()
        } /* else {
            this._router.navigate(['/inicio'])
            swal({
                type: 'warning',
                text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            })
        } */

    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.calles.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
    }


    ngDoCheck() {
        this.segundoPaso = false
        this.cert_seleccionado = false
        this._changeDetector.detectChanges()
        for (let i = 0; i < this.certSelected.length; i++) {
            for (let n = 0; n < this.certSelected[i].certs.length; n++) {
                const element2 = this.certSelected[i].certs[n];
                if (element2.selected) {
                    this.cert_seleccionado = true
                }
            }
        }

        if (this.lista_dir.value.length > 0) {
            this.segundoPaso = true
        }
    }

    someFunction(diridx, o, item, event) {
        console.log("someFunction()")
        console.log("item", item);
        console.log("event", event);
        var dirEncontrada = false

        if (this.certSelected.length > 0) {
            var cont = 0
            for (let i = 0; i < this.certSelected.length; i++) {
                const element = this.certSelected[i];
                if (item.rol == element.rol) {
                    dirEncontrada = true
                }
                cont++
            }
            if (cont == this.certSelected.length) {
                if (!dirEncontrada) {
                    this.certSelected.push({
                        calle: item.calle,
                        num: item.num,
                        rol: item.rol,
                        idDirec: item.info._PDI_Id_Direcc,
                        folio: item.folio,
                        certs: []
                    })
                    for (let i = 0; i < this.valores_cert.length; i++) {
                        const element = this.valores_cert[i];

                        // this.documentos_obligatorios[i] = false;
                        this.certSelected[this.certSelected.length - 1].certs.push({
                            nombre: element.nombre,
                            alias: element.alias,
                            selected: false,
                            valor: element.valor,
                            valorNoFormat: element.valorNoFormat,
                            estampilla: element.estampilla,
                            numAsigm: ""
                        })
                    }
                }
            }


        } else {
            console.log("certSelected.length no es mayor a 0 item", item)
            this.certSelected.push({
                calle: item.calle,
                num: item.num,
                rol: item.rol,
                idDirec: item.info._PDI_Id_Direcc,
                folio: item.folio,
                certs: []
            })
            console.log("this.certSelected", this.certSelected)
            for (let i = 0; i < this.valores_cert.length; i++) {
                const element = this.valores_cert[i];
                // this.documentos_obligatorios[i] = false;
                this.certSelected[0].certs.push({
                    nombre: element.nombre,
                    alias: element.alias,
                    selected: false,
                    valor: element.valor,
                    valorNoFormat: element.valorNoFormat,
                    estampilla: element.estampilla,
                    numAsigm: ""
                })
            }
        }


        console.log("this.certSelected", this.certSelected)
        if (event.source == undefined) {

            for (let i = 0; i < this.certSelected.length; i++) {
                const element = this.certSelected[i];
                for (let x = 0; x < this.certSelected[i].certs.length; x++) {
                    const element2 = this.certSelected[i].certs[x];
                    if (element2.alias == "ASIGM") {
                        this.certSelected[i].certs[x].numAsigm = this.numAsig[i]
                    }
                }
            }

        } else {
            for (let i = 0; i < this.certSelected.length; i++) {
                const element = this.certSelected[i];
                if (element.rol == item.rol) {
                    console.log("element.rol", element.rol)
                    console.log("item.rol", item.rol)

                    for (let x = 0; x < this.certSelected[i].certs.length; x++) {
                        const element2 = this.certSelected[i].certs[x];
                        if (event.source.value == element2.alias) {
                            console.log("element2.alias", element2.alias)
                            //buscar si esta seleccionado el 'CERTIFICADO DE VIVIENDA SOCIAL'
                            if (element2.alias == 'CVS') {
                                console.log("CERTIFICADO DE VIVIENDA SOCIAL SELECCIONADO")
                                // this.documentos_obligatorios[i] = event.checked;

                                this.documentos_obligatorios[i] = event.checked;//{ selected: event.checked, };
                                //ver si es el primer segundo o tercer rol
                            }

                            console.log("event.source.value", event.source.value)
                            console.log("element2.alias", element2.alias)
                            this.certSelected[i].certs[x].selected = event.checked

                            if (element2.alias == "ASIGM") {
                                this.certSelected[i].certs[x].numAsigm = this.numAsig[i]
                            }
                        }
                    }
                }
            }
        }

        this.mostrarNum = true
        console.log("this.documentos_obligatorios", this.documentos_obligatorios)
        console.log("this.certSelected", this.certSelected)
        console.log("this.dirs", this.dirs)
    }

    createItem(): FormGroup {
        return this._formBuilder.group({
            aup: false,
            cip: false,
            cnum: false,
            zn: false
        });
    }

    solicitar_Certificados() {
        // this.dialog.open(this.modal_sol_cert, this.dialogConfig)
        this.mostrar_solicitud = true
    }

    cerrar_vista() {
        this.mostrar_solicitud = false;
        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
        this.modificando = false
        this.primerPaso = false;
        this.dirs = []
        this.rut.reset();
    }

    buscar_info_sol() {
        this.spinner.show()

        var rutSinPuntos = this.firstFormGroup.controls.rut.value
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "")
            }
            console.log("entre en el if de los puntos", rutSinPuntos)
        }

        this.continuar = false
        this._userService.traerInfo_rut(rutSinPuntos).subscribe(
            response => {
                this.rut_encontrado = false
                if (response) {
                    this.info_rut = response.data
                    this.emailValido = this.info_rut.emailValido
                    console.log(this.info_rut)
                    console.log(this.info_rut.email == '')
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(String(this.info_rut.email).toLowerCase())) {

                        this.continuar = true
                    }

                    this.firstFormGroup.patchValue({ mod_solicitante: { nombre: this.info_rut.nombre } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { apellido_p: this.info_rut.apellido_p } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { apellido_m: this.info_rut.apellido_m } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { calle: this.info_rut.calle } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { num: this.info_rut.numero } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { complemento: this.info_rut.complemento } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { telefono: this.info_rut.telefono } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { cel: this.info_rut.celular } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { ciudad: this.info_rut.ciudad } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { comuna: this.info_rut.comuna } });
                    this.firstFormGroup.patchValue({ mod_solicitante: { email: this.info_rut.email } });

                    this.primerPaso = true
                    this.rut_encontrado = true
                    this.spinner.hide()
                    this._changeDetector.detectChanges()
                }
            }, error => {
                this.spinner.hide()
                this.modificando = true
                this.rut_encontrado = false
            }
        )
    }

    mod_inforut() {
        this.firstFormGroup.controls.mod_solicitante.setValue({
            nombre: this.info_rut.nombre ? this.info_rut.nombre : " ",
            apellido_p: this.info_rut.apellido_p ? this.info_rut.apellido_p : " ",
            apellido_m: this.info_rut.apellido_m ? this.info_rut.apellido_m : " ",
            calle: this.info_rut.calle ? this.info_rut.calle : " ",
            num: this.info_rut.numero ? this.info_rut.numero : " ",
            complemento: this.info_rut.complemento ? this.info_rut.complemento : " ",
            telefono: this.info_rut.telefono ? this.info_rut.telefono : " ",
            cel: this.info_rut.celular ? this.info_rut.celular : " ",
            ciudad: this.info_rut.ciudad ? this.info_rut.ciudad : " ",
            comuna: this.info_rut.comuna ? this.info_rut.comuna : " ",
            email: this.info_rut.email ? this.info_rut.email : " "
        })
        this.primerPaso_mod = true
        this.primerPaso = false
        this.modificando = true

    }

    guarda_mod() {
        this.spinner.show()
        this._userService.save_info_mod_solicitante(this.info_rut.rut, this.firstFormGroup.controls.mod_solicitante.value).subscribe(
            response => {
                this.spinner.hide()
                console.log(response)
                this.modificando = false
                swal({
                    type: 'success',
                    title: 'Guardado!',
                    text: response.message,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });

            }, error => {
                this.spinner.hide()
                console.log(error)
                swal({
                    type: 'error',
                    title: 'Ha ocurrido un error!',
                    text: error._body,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });
            }
        )
    }

    registro_sol() {

        var rutSinPuntos = this.firstFormGroup.controls.rut.value
        if (this.firstFormGroup.controls.rut.value.toString().includes(".")) {
            rutSinPuntos = this.firstFormGroup.controls.rut.value.toString().replace(".", "")
            if (rutSinPuntos.includes(".")) {
                rutSinPuntos = rutSinPuntos.replace(".", "")
            }
            console.log("entre en el if de los puntos", rutSinPuntos)
        }

        var userinfo = {
            rut: rutSinPuntos,
            nombre: this.firstFormGroup.controls.mod_solicitante.value.nombre,
            app: this.firstFormGroup.controls.mod_solicitante.value.apellido_p,
            apm: this.firstFormGroup.controls.mod_solicitante.value.apellido_m,
            dir: this.firstFormGroup.controls.mod_solicitante.value.calle,
            num: this.firstFormGroup.controls.mod_solicitante.value.num,
            dircom: this.firstFormGroup.controls.mod_solicitante.value.complemento,
            telefono: this.firstFormGroup.controls.mod_solicitante.value.telefono,
            celular: this.firstFormGroup.controls.mod_solicitante.value.cel,
            ciudad: this.firstFormGroup.controls.mod_solicitante.value.ciudad,
            comuna: this.firstFormGroup.controls.mod_solicitante.value.comuna,
            email: this.firstFormGroup.controls.mod_solicitante.value.email,
        }

        console.log(userinfo)
        this._userService.save_solicitante(userinfo).subscribe(response => {
            console.log(response)
            swal({
                type: 'success',
                title: 'Registrado!',
                text: response.message,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(() => {
            }, (dismiss) => {
                if (dismiss === 'timer') {
                }
            });
            this.buscar_info_sol()
            this.modificando = false
        }, error => {
            console.log(error)
            swal({
                type: 'error',
                title: 'Ha ocurrido un error!',
                text: error._body,
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(() => {
            }, (dismiss) => {
                if (dismiss === 'timer') {
                }
            });
        })
    }

    cancelar_mod() {

        if (this.rut_encontrado) {
            this.modificando = false
            this.primerPaso_mod = false
            this.primerPaso = true
        } else {
            this.modificando = false
            this.rut_encontrado = false
            this.primerPaso = false
            this.primerPaso_mod = false
        }

    }



    buscar_info_propiedad_rol() {
        this.spinner.show()


        this._userService.traerInfo_propiedad_rol(this.secondFormGroup.controls.rol.value).subscribe(
            response => {
                console.log(response)
                if (response.status == "error") {
                    this.spinner.hide()
                    this.secondFormGroup.controls.dir.setValue("")
                    this.secondFormGroup.controls.num.setValue("")
                    this.secondFormGroup.controls.rol.setValue("")
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else if (response.status == "bloqueado") {
                    this.spinner.hide()
                    this.secondFormGroup.controls.dir.setValue("")
                    this.secondFormGroup.controls.num.setValue("")
                    this.secondFormGroup.controls.rol.setValue("")
                    swal({
                        type: 'warning',
                        title: 'El ROL ingresado se encuentra bloqueado.',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else {
                    this.spinner.hide()
                    var rol_yaExiste = false
                    if (this.dirs.length <= 2) {
                        for (let i = 0; i < this.dirs.length; i++) {
                            if (this.dirs[i].rol == response.rol) {
                                rol_yaExiste = true
                            }
                        }
                        if (!rol_yaExiste) {
                            if (response.dirs.length > 1) {
                                this.dirrecciones = response
                                this.dialog.open(this.direccionesDialog, { disableClose: true })
                            } else {

                                var dir = {
                                    calle: response.dirs[0].calle,
                                    num: response.dirs[0].num,
                                    dirComp: response.dirs[0].direcCompleta,
                                    cip: response.cip,
                                    cnum: response.cnum,
                                    aup: response.aup,
                                    rol: response.rol,
                                    folio: response.folio,
                                    info: response.info
                                }

                                console.log("dir elegid=asdaffdafs", dir)

                                this.dirs.push(dir)
                                this.lista_dir.next(this.dirs)
                                this._changeDetector.detectChanges();
                                this.secondFormGroup.controls.dir.setValue("")
                                this.secondFormGroup.controls.num.setValue("")
                                this.secondFormGroup.controls.rol.setValue("")
                                if (this.dirs.length > 0) {
                                    this.segundoPaso = true
                                }
                                console.log(this.lista_dir)
                            }


                        } else {

                            this.secondFormGroup.controls.dir.setValue("")
                            this.secondFormGroup.controls.num.setValue("")
                            this.secondFormGroup.controls.rol.setValue("")
                            swal({
                                type: 'warning',
                                title: 'Atención!',
                                text: 'El rol ingresado ya esta agregado',
                                confirmButtonColor: '#3F51B5',
                                confirmButtonText: 'Aceptar',
                                timer: 3500
                            }).then(() => {
                            }, (dismiss) => {
                                if (dismiss === 'timer') {
                                }
                            });

                        }

                    } else {
                        this.spinner.hide()
                        this.secondFormGroup.controls.dir.setValue("")
                        this.secondFormGroup.controls.num.setValue("")
                        this.secondFormGroup.controls.rol.setValue("")
                        this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                            duration: 2000,
                        });
                    }
                }

            }, error => {
                this.spinner.hide()

                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                swal({
                    type: 'error',
                    title: 'Ha ocurrido un error!',
                    text: error._body,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });
            }
        )
    }

    buscar_info_propiedad_direccion() {
        this.spinner.show()
        var calle = ""

        calle = this.secondFormGroup.controls.dir.value


        calle.toUpperCase()
        this._userService.traerInfo_propiedad_direccion(calle.toUpperCase(), this.secondFormGroup.controls.num.value).subscribe(
            response => {
                this.spinner.hide()
                console.log("entre en buscar por direccion", response)
                var dir_yaExiste = false
                if (response.status == "error") {
                    this.secondFormGroup.controls.dir.setValue("")
                    this.secondFormGroup.controls.num.setValue("")
                    this.secondFormGroup.controls.rol.setValue("")

                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else if (response.status == "bloqueado") {
                    this.spinner.hide()
                    this.secondFormGroup.controls.dir.setValue("")
                    this.secondFormGroup.controls.num.setValue("")
                    this.secondFormGroup.controls.rol.setValue("")
                    swal({
                        type: 'warning',
                        title: 'El ROL ingresado se encuentra bloqueado.',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else {
                    this.spinner.hide()
                    var rol_yaExiste = false
                    if (this.dirs.length <= 2) {
                        for (let i = 0; i < this.dirs.length; i++) {
                            if (this.dirs[i].rol == response.rol) {
                                rol_yaExiste = true
                            }
                        }
                        if (!rol_yaExiste) {
                            if (response.dirs.length > 1) {
                                this.dirrecciones = response
                                this.dialog.open(this.direccionesDialog, { disableClose: true })
                            } else {

                                var dir = {
                                    calle: response.dirs[0].calle,
                                    num: response.dirs[0].num,
                                    dirComp: response.dirs[0].direcCompleta,
                                    cip: response.cip,
                                    cnum: response.cnum,
                                    aup: response.aup,
                                    rol: response.rol,
                                    folio: response.folio,
                                    info: response.info

                                }
                                this.dirs.push(dir)
                                this.lista_dir.next(this.dirs)
                                this._changeDetector.detectChanges();
                                this.secondFormGroup.controls.dir.setValue("")
                                this.secondFormGroup.controls.num.setValue("")
                                this.secondFormGroup.controls.rol.setValue("")
                                if (this.dirs.length > 0) {
                                    this.segundoPaso = true
                                }
                                console.log(this.lista_dir)
                            }


                        } else {

                            this.secondFormGroup.controls.dir.setValue("")
                            this.secondFormGroup.controls.num.setValue("")
                            this.secondFormGroup.controls.rol.setValue("")
                            swal({
                                type: 'warning',
                                title: 'Atención!',
                                text: 'El rol ingresado ya esta agregado',
                                confirmButtonColor: '#3F51B5',
                                confirmButtonText: 'Aceptar',
                                timer: 3500
                            }).then(() => {
                            }, (dismiss) => {
                                if (dismiss === 'timer') {
                                }
                            });

                        }

                    } else {
                        this.spinner.hide()
                        this.secondFormGroup.controls.dir.setValue("")
                        this.secondFormGroup.controls.num.setValue("")
                        this.secondFormGroup.controls.rol.setValue("")
                        this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                            duration: 2000,
                        });
                    }
                }

            }, error => {
                console.log(error)
                this.spinner.hide()
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                swal({
                    type: 'error',
                    title: 'Ha ocurrido un error!',
                    text: error._body,
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });
            }
        )
    }


    insertarDir() {
        var rol_yaExiste = false
        if (this.dirs.length <= 2) {
            for (let i = 0; i < this.dirs.length; i++) {
                if (this.dirs[i].rol == this.dirrecciones.rol) {
                    rol_yaExiste = true
                }
            }
            if (!rol_yaExiste) {
                console.log(this.dirSeleccionada)
                console.log("direccionesss", this.dirSeleccionada)
                var dir = {
                    calle: this.dirSeleccionada.calle,
                    num: this.dirSeleccionada.num,
                    dirComp: this.dirSeleccionada.direcCompleta,
                    rol: this.dirSeleccionada.rol,
                    folio: this.dirSeleccionada.folio,
                    info: this.dirrecciones.info,
                }
                this.dirs.push(dir)
                this.lista_dir.next(this.dirs)
                console.log(this.lista_dir)
                this._changeDetector.detectChanges();
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                if (this.dirs.length > 0) {
                    this.segundoPaso = true
                }
                this.dialog.closeAll()
            } else {
                this.dialog.closeAll()
                this.secondFormGroup.controls.dir.setValue("")
                this.secondFormGroup.controls.num.setValue("")
                this.secondFormGroup.controls.rol.setValue("")
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'El rol ingresado ya esta agregado',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });

            }

        } else {
            this.dialog.closeAll()
            this.spinner.hide()
            this.secondFormGroup.controls.dir.setValue("")
            this.secondFormGroup.controls.num.setValue("")
            this.secondFormGroup.controls.rol.setValue("")
            this.snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                duration: 2000,
            });
        }
    }

    eliminar_direccion(i, item) {
        console.log(i)
        console.log(item)
        this.segundoPaso = false
        console.log(this.lista_dir)
        var filter = this.dirs.filter((vale, index, arr) => {
            return index != i
        })

        if (this.certSelected.length > 0) {
            for (let i = 0; i < this.certSelected.length; i++) {
                const element = this.certSelected[i];
                if (element.rol == item.rol) {
                    this.certSelected.splice(i, 1)
                }
            }
        }
        if (this.lista_dir.value.length > 0) {
            this.segundoPaso = true
        }


        this.dirs = filter
        this.lista_dir.next(this.dirs)
        this._changeDetector.detectChanges();
    }

    cerrar_dialog() {

        this.dialog.closeAll()
        this.primerPaso = false
        this.segundoPaso = false
        this.tercerPaso = false
        this.info_rut = []
        this.dirs = []
    }

    calcular_total() {
        this.cantidadCert = 0
        console.log(this.certSelected)
        this.valor_total_cert = 0
        for (let i = 0; i < this.certSelected.length; i++) {
            for (let x = 0; x < this.certSelected[i].certs.length; x++) {
                const element = this.certSelected[i].certs[x];
                if (element.selected) {
                    this.valorTotalEstampilla = element.estampilla
                    this.cantidadCert++
                    console.log("entre en calcular", element)

                    if (element.alias == "ASIGM") {
                        this.valorOnlyCert = this.valorOnlyCert + (element.valorNoFormat * this.numAsig[i])
                        this.valor_total_cert = this.valor_total_cert + element.estampilla + (element.valorNoFormat * this.numAsig[i])
                    } else {
                        this.valor_total_cert = this.valor_total_cert + element.estampilla + element.valorNoFormat
                        this.valorOnlyCert = this.valorOnlyCert + element.valorNoFormat
                    }
                }
            }

        }
        console.log("Valor total", this.valor_total_cert)
        this.mostrar_total2 = formatNumber(this.valor_total_cert, 'cl')
        this.mostrar_total = this.valor_total_cert
        console.log(this.mostrar_total)
    }



    toLobby() {

        this._router.navigateByUrl('/')

        this.dialog.closeAll();
    }



    private docId() {
        let text = '';
        const possible = '0123456789';

        for (let i = 0; i < 8; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }


    closeTab() {
        window.close();
    }

    async onSubmit() {
        this.pagando = true
        console.log("entre en ell onsubmit")
        this.spinner.show()
        var now = moment(new Date()).format('YYYY-MM-DD').split("-")
        console.log(this.dirs)
        this.id_carro = this.docId();

        this.carro_deptos = `<?xml version="1.0" encoding="utf-8"?>
        <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
        <soapenv:Header/>
        <soapenv:Body>
        <tem:Traer_IngDeptos>
        <tem:Codigo_Area>1</tem:Codigo_Area>
        <tem:Ano_Proceso>${now[0]}</tem:Ano_Proceso>
        <!--Optional:-->
        <tem:Item_Pago>5</tem:Item_Pago>
        <!--Optional:-->
        <tem:CodigoMunicipalidad>0</tem:CodigoMunicipalidad>
        </tem:Traer_IngDeptos>
        </soapenv:Body>
        </soapenv:Envelope>`

        this._userService.casWsConsumo(this.mostrar_total, this.info_rut, this.carro_deptos).subscribe(res => {
            console.log(res)
            if (res.code == "200") {
                this._userService.casWsConsumoCuentas(this.mostrar_total, this.info_rut, res.resp, this.valorOnlyCert, this.valorTotalEstampilla, this.cantidadCert).subscribe(resCuentas => {
                    console.log(resCuentas)
                    if (resCuentas.code == "200") {
                        this._userService.casWsCreateGiro(this.mostrar_total, this.mostrar_total2, this.info_rut, resCuentas.resp, resCuentas.item_pago, this.certSelected, this.observacion.value, this.dbx_links).subscribe(respGiro => {
                            this.spinner.hide()
                            swal({
                                type: 'success',
                                title: 'Todo listo!',
                                text: "Para continuar debe ingresar sus datos en el portal, una vez realizado el pago, le llegara un correo de confirmación dentro de los próximos 10 minutos.",
                                confirmButtonColor: '#3F51B5',
                                confirmButtonText: 'Aceptar',
                                onClose: () => {
                                    this._router.navigate([`/inicio`]);
                                    window.open("https://ww16.e-com.cl/Pagos/PagosVariosv3/?id=70", "_blank");
                                }
                            }).then(() => {
                            }, (dismiss) => {
                                if (dismiss === 'timer') {
                                }
                            });
                        }, error => {
                            console.log(error)
                            swal({
                                type: 'warning',
                                title: 'Atención!',
                                text: "Ha ocurrido un error",
                                confirmButtonColor: '#3F51B5',
                                confirmButtonText: 'Aceptar',
                                timer: 3500
                            }).then(() => {
                            }, (dismiss) => {
                                if (dismiss === 'timer') {
                                }
                            });
                        })
                    } else if (res.code == "500") {
                        console.log(resCuentas)
                        swal({
                            type: 'warning',
                            title: 'Atención!',
                            text: "Ha ocurrido un error",
                            confirmButtonColor: '#3F51B5',
                            confirmButtonText: 'Aceptar',
                            timer: 3500
                        }).then(() => {
                        }, (dismiss) => {
                            if (dismiss === 'timer') {
                            }
                        });
                    }
                }, error => {
                    console.log(error)
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: "Ha ocurrido un error",
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                })
            } else if (res.code == "500") {
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "Ha ocurrido un error",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                });
            }

        }, error => {
            console.log(error)
            swal({
                type: 'warning',
                title: 'Atención!',
                text: "Ha ocurrido un error",
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
            }).then(() => {
            }, (dismiss) => {
                if (dismiss === 'timer') {
                }
            });
        })

    }

    finalizarBTN() {
        this._router.navigate([`/`]);
        this.dialog.closeAll();
    }

    verObligatorios(cert) {
        console.log("cert", cert)

        // console.log("cert.TRAEXP_Oblig", cert.TRAEXP_Oblig)
        // var obligatorios;
        // for (let index = 0; index < cert.TRAEXP_Oblig.length; index++) {
        //   const element = cert.TRAEXP_Oblig[index];

        //   // console.log("obligatorios",obligatorios)



        //   obligatorios = obligatorios == undefined ?
        //     (' <br><div style="text-align: justify; padding: 0 1em 0 1em" >  <i class="material-icons">description</i>' + element.nombre + '</div> <br>') :
        //     (obligatorios + '<div style="text-align: justify; padding: 0 1em 0 1em" > <i class="material-icons">description</i>' + element.nombre + '</div> <br>');
        //   console.log("obligatorios", obligatorios)
        // }
        // swal({
        //     type: "info",
        //     title: "Documentos Obligatorios ",
        //     text: '<br>( ' + cert.TRAEXP_Tipo_Sanitizado + ' )<br>' + obligatorios,

        //     showConfirmButton: true,
        //     confirmButtonText: 'Aceptar',
        //     allowOutsideClick: false
        //   })

        swal({
            type: "info",
            title: "Documentos Obligatorios ",
            text: '<br>Certificado de Avalúo Fiscal Detallado<br>',

            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        })
    }

    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }


    llenarTabla(dir) {
        console.log("llenarTabla(dir) dir", dir)
        this.cargando = true


        this.rowsObligatorios = []
        this.files = []
        this.actualSizeFiles = 0

        console.log("dir", dir)
        console.log("this.certSelected", this.certSelected)

        var contador = 0

        this.rowsObligatorios.push(
            {
                id: contador,
                name: 'Certificado de Avalúo Fiscal Detallado',
                // newAttached: false  //para saber si hay adjuntos nuevos
            }
        )


        console.log('this.rowsObligatorios.find(element=>element.name == obligatorio.nombre)', this.rowsObligatorios.find(element => element.name.includes("Certificado de Avalúo Fiscal Detallado")));

        console.log("this.rowsObligatorios", this.rowsObligatorios)
        console.log("this.seleccion_cert", this.seleccion_cert)
        var archivos = localStorage.getItem("archivos_marcados")
        if (archivos) {
            var subidos = { "archivosSubidos": false };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        }


        this.cargando = false;

    }
    confirmarAdjuntarNuevos() {

        console.log("Se subiran nuevos archivos")
        this.dialogRef = this.dialog.open(this.modalDocumentos, {
            id: "modalDocumentos2",
            disableClose: true,
            width: "60%"
        });
    }



    adjuntar(dir) {
        console.log("dir", dir)

        this.seleccion_dire = this.capitalize((dir.dirComp).toLowerCase())

        // this.seleccion_num = dir.num
        this.seleccion_rol = dir.rol
        this.llenarTabla(dir)
        this.dialogRef = this.dialog.open(this.modalDocumentos, {
            id: "modalDocumentos",
            disableClose: true,
            width: "60%"
        });

    }

    limpiarDocs() {
        this.rowsObligatorios = []
        this.files = []
        this.peso = 0
        this.seleccion_dire = ''
        this.seleccion_num = ''
        this.seleccion_rol = ''
        this.seleccion_cert = ''
        this.seleccion_nameCert = ''
    }

    uploadAllfiles() {

        console.log("uploadAllfiles()")
        let formType = 'Certificado-' + this.seleccion_cert.toUpperCase() + "-ROL:'" + this.seleccion_rol + "'";

        this.spinner.show();
        // this.onActivate()
        this._userService.uploadFiles(this.files, formType).subscribe(
            response => {

                console.log("uploadFiles response", response)
                this.spinner.hide();
                var subidos = { "archivosSubidos": true };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                let alert = { icon: 'success', text: '', title: '' }
                // this.onActivate()
                if (response.code == 99 && response.url) {
                    alert.icon = 'success'
                    alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>'
                    alert.title = 'Archivos cargados'


                    console.log("response.url", response.url)
                    for (let index = 0; index < this.dirs.length; index++) {
                        const dire = this.dirs[index]


                        // if (this.documentos_obligatorios[index]) //si documentos_obligatorios y en else poner subido true
                        // {
                        //     console.log(`index ${index} tiene documentos obligatorios por subir`)
                        // } else {
                        //     console.log(`index ${index} no tiene documentos obligatorios por subir`)
                        // }

                        console.log("this.seleccion_dire", this.seleccion_dire)
                        console.log("dire.dirComp", dire.dirComp)
                        console.log("this.seleccion_rol", this.seleccion_rol)
                        console.log("dire.rol", dire.rol)

                        if ((this.seleccion_dire).toUpperCase() == dire.dirComp.toUpperCase()
                            // && this.seleccion_num == dire.num

                            && this.seleccion_rol.toUpperCase() == dire.rol.toUpperCase()) {


                            //validar que no falte algun archivo


                            dire.url = response.url
                            dire.obligatorios_subidos = true;
                            dire.subido = true
                            // for (let i = 0; i < dire.cert.length; i++) {
                            //     const certificado = dire.cert[i]
                            //     // console.log("this.seleccion_cert", this.seleccion_cert)
                            //     console.log("certificado.name_id", certificado.name_id)
                            //     // if (certificado.name_id == this.seleccion_cert) {
                            //     certificado.url = response.url//no importa que no recorra uno por uno pq es un paquete con todos los archivos del certificado
                            //     certificado.subido = true
                            //     // }

                            //     dire.obligatorios_subidos = true;
                            // }


                            // for (let index = 0; index < this.documentos_obligatorios.length; index++) {
                            //     const element = this.documentos_obligatorios[index];
                            //     dire.url = response.url
                            //     dire.obligatorios_subidos = true;
                            //     dire.subido = true
                            // }


                        }

                        if (this.dirs.length == index + 1) {
                            console.log(this.dirs[index])
                            this.dialog.closeAll()
                            this.limpiarDocs()

                            this.validarDocs()
                        }
                    }

                    this.archivosSubidos = true

                    console.log("this.dirs", this.dirs)
                } else if (response.code == 98) {
                    alert.icon = 'error'
                    alert.text = '<p>No se adjuntaron documentos</p>'
                    alert.title = 'Archivos no cargados'
                } else if (response.code == 97) {
                    alert.icon = 'error'
                    alert.text = '<p>No se adjuntaron documentos</p>'
                    alert.title = 'Archivos no cargados'
                } else if (response.code == 96) {
                    alert.icon = 'error'
                    alert.text = '<p>Archivos no permitidos</p>'
                    alert.title = 'Archivos no cargados'
                }
                else {
                    alert.icon = 'error'
                    alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
                    alert.title = 'Archivos no cargados'
                }

                swal({
                    icon: alert.icon,
                    title: alert.title,
                    text: alert.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(
                    () => {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                );

            },
            error => {
                this.spinner.hide();
                console.log("un error", error);
                var subidos = { "archivosSubidos": true };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                swal({
                    icon: 'error',
                    title: 'Error al subir documentación',
                    text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(
                    () => {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                );
            }
        )
    }




    handleFileInput2(files: FileList, row) {
        console.log("handleFileInput2()")
        console.log("files", files)
        console.log("row", row)

        let file: File
        file = files.item(0)



        if (row.id || row.id == 0) {
            for (let index = 0; index < this.rowsObligatorios.length; index++) {

                if (this.rowsObligatorios[index].id == row.id) {
                    this.nombreArchivo = files.item(0).name
                    let peso = (files.item(0).size / 1000000) + ' MB'

                    this.rowsObligatorios[index].archivo = this.nombreArchivo
                    this.rowsObligatorios[index].peso = peso
                    this.rowsObligatorios[index].newAttached = false

                    this.files[index] = ({ name: this.rowsObligatorios[index].name, doc: file })

                }
            }
        } else {
            this.archivoCargado = files.item(0)
            if (files.item(0).name && this.documentoNombre != '') {
                this.btnAccept = true
                let actualRow = localStorage.getItem("adjuntos");
                this.nombreArchivo = files.item(0).name
                this.files[this.rowsObligatorios.length] = ({ name: this.documentoNombre, doc: file })
                this.peso = (files.item(0).size / 1000000) + ' MB'
            }
        }
        this.actualSizeFiles = this.actualSizeFiles + files.item(0).size
        this.rows1[0].total = this.actualSizeFiles
        this.rows1 = [...this.rows1];

        //check max size file
        this.checksSize(this.files.length - 1)
        this.revisarTabla()
    }


    validarDocs() {
        console.log("validarDocs()")
        console.log("this.dirs", this.dirs)
        var docsSubidos = true

        for (let i = 0; i < this.dirs.length; i++) {

            const direccion = this.dirs[i];
            console.log("this.dirs i", i)
            console.log("direccion.subido", direccion.subido)


            if (this.documentos_obligatorios[i]) //si documentos_obligatorios y en else poner subido true
            {
                console.log(`la direccion index ${i} tiene documentos obligatorios por subir`)
                if (!direccion.subido) {
                    console.log(`${i} tiene documentos obligatorios por subir aún`)
                    docsSubidos = false;//si en algun momento queda false no deja pasar
                }

                this.dbx_links[i] = this.dirs[i].url;
            } else {
                console.log(`la direccion index ${i} no tiene documentos obligatorios por subir`)

            }




        }
        this.obligatorios = docsSubidos;

        console.log("dbx_links", this.dbx_links)
        console.log("docSubidos", docsSubidos)
        console.log("obligatorios", this.obligatorios)
    }


    checksSize(index = null) {
        if (this.actualSizeFiles > this.maxSizeFiles) {
            this.deleteFile2(index)

        }
    }

    revisarTabla() {
        var bandera = true
        this.pase = false
        /*    console.log("revisando tabla", this.rows) */
        for (let tabla = 0; tabla < this.rowsObligatorios.length; tabla++) {
            /*    console.log("Index ", tabla, "bandera ", bandera) */

            if (!this.rowsObligatorios[tabla].archivo || this.rowsObligatorios[tabla].archivo == "") {
                bandera = false
            }

            if ((tabla + 1) == this.rowsObligatorios.length) {
                /*   console.log("Recorri la tabla", bandera) */
                if (bandera == true) {
                    this.pase = true
                    /*   console.log(this.pase) */
                }
            }
        }
    }

    deleteFile2(row) {
        var zip = localStorage.getItem("ZipURL")
        /*  console.log(zip) */
        if (zip) {
            var subidos = { "archivosSubidos": true };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        } else {
            var subidos = { "archivosSubidos": false };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        }

        /* console.log(row) */
        this.rowsObligatorios.splice(row.id, 1)
        this.files.splice(row.id, 1)

        this.clearSize()
    }
    clearSize() {
        this.actualSizeFiles = 0
        /* console.log(this.files) */
        for (let index = 0; index < this.files.length; index++) {
            const element = this.files[index];
            if (element) {
                this.actualSizeFiles = this.actualSizeFiles + element.doc.size
            }
        }
        //check max size file
        this.checksSize(this.files.length - 1)
    }
    async logout() {
        this.store.dispatch(new FormActions.FormUpdate('0', ''))
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");

        const response = await this.claveUnicaService.logoutClaveUnica()
        console.log('Deslogeo exitoso:', response);

        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
            duration: 3000,
        });
        this.back()
    }

    openPerfil() {
        this.dialog.open(PerfilComponent)
    }

    back() {
        this._router.navigate(['/inicio'])
    }


    searchUser() {
        /* Buscar si existe en fm */
        let identityData = this._userService.getIdentity();
        let rut = identityData.rut + identityData.dv
        this._userService.buscarUsuario(rutClean(rut)).subscribe(
            response => {
                console.log(response);
                if (response.message) {
                    this.spinner.hide();
                    console.log(response);
                }
                if (response.register) {
                    this.spinner.hide();
                    console.log(response);

                    this.dialog.open(RegistroComponent, {
                        id: "logindialog",
                        width: '50vw', // Ajusta el ancho
                        height: 'auto', // Ajusta la altura
                        disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                    });
                }

                if (response.update) {
                    this.spinner.hide();
                    console.log(response);

                    this.dialog.open(RegistroComponent, {
                        id: "logindialog",
                        width: '50vw', // Ajusta el ancho
                        height: 'auto', // Ajusta la altura
                        disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                    });
                }
            },
            error => {
                let e = JSON.parse(error._body);
                this.spinner.hide();
            }
        )
    }
}